import React, { useEffect, useRef, useState } from 'react';
import './DataTable.css';
import { useParams } from "react-router-dom"
import ReactDOM from 'react-dom';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import useRequestResource from '../../hooks/useRequestResource';
import { TableA } from '../../tables/tableA'
import { TableB } from '../../tables/tableB'
import Accordion from 'react-bootstrap/Accordion';
import InstrumentTab from '../utils/instrumenttab';
import { LatestTab } from '../utils/latesttab';
import { Grid, Button, Menu, MenuItem } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './_card.scss'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import CircularProgress from '@mui/material/CircularProgress';
import { CategoryTab } from '../utils/categoryTable';
import { DivIcon } from 'leaflet';
import logo from "../../testLogo1.png"
import GMap from '../utils/maptab';
import { Row } from 'react-bootstrap';
import * as XLSX from 'xlsx';
// import '../../style.css'


const DataTable = () => {
  const { id } = useParams();
  const { processedDataList, getProcessedDataList } = useRequestResource({ endpoint: "auth", query: "processedrecords", resourceLabel: "Processed Records" })
  const [tables, setTables] = useState([])
  const [instrumentTab, setInstrumentTab] = useState(<div></div>)
  const [latestTab, setLatestTab] = useState(<div></div>)
  const [categoryTab, setCategoryTab] = useState(<div></div>)
  const startDate = useRef(Date.now())
  const endDate = useRef(Date.now());
  const [start, setStart] = useState(Date.now())
  const [end, setEnd] = useState(Date.now())
  const [instrument, setInstrument] = useState(null)
  const offset = 25
  const [printing, setPrinting] = useState(false)
  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const isExportOpen = Boolean(exportAnchorEl);

  const handleExportClick = (event) => {
    setExportAnchorEl(event.currentTarget);
  };

  const handleExportClose = () => {
    setExportAnchorEl(null);
  };

  const handleExportOption = (format) => {
    handleExportClose();
    if (format === 'pdf') {
      generatePDF();
    } else if (format === 'excel-list') {
      handleExportExcelList();
    } else if (format === 'excel-table') {
      handleExportExcelTable();
    } else if (format === 'csv') {
      handleExportCSV();
    }
  };

  const addToDoseAndMaxList = (data, list, categoryName) => {
    // Compute Singapore hour from UTC timestamp (avoid relying on client timezone)
    const dt = new Date(data.timestamp);
    const sgtHours = (dt.getUTCHours() + 8) % 24;
    let adjustedIndex = -1;
    // Calculate the index based on the hour value
    if (sgtHours >= 7 && sgtHours <= 23) {
      // For hours 07 to 23
      adjustedIndex = sgtHours - 7;
    } else {
      // For hours 00 to 06
      adjustedIndex = sgtHours + 17;
    }
    // In 24hours, 8am - 7pm is ALWAYS IGNORED as 7am-7pm is covered by 12h data
    if (adjustedIndex >= 1 && adjustedIndex <= 11) {
      return;
      // For Non B categories, 7pm - 7am is just covered by a 12h data
    } else if (categoryName !== "B - Residential" && adjustedIndex >= 13 && adjustedIndex <= 23) {
      return;
    } else {
      list[adjustedIndex] = data;
    }
  }

  const addToLeq12 = (data, list) => {
    const dt = new Date(data.timestamp);
    const sgtHours = (dt.getUTCHours() + 8) % 24;
    if (sgtHours === 7) {
      list[0] = data;
    } else {
      list[1] = data;
    }

    return;
  }
  useEffect(() => {
    getProcessedDataList({
      instrument: instrument ? instrument.id : id ?? null, start: new Date(startDate.current).toLocaleDateString('en-GB', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).split('/').reverse().join('-'), end: new Date(endDate.current).toLocaleDateString('en-GB', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).split('/').reverse().join('-')
    })
  }, [getProcessedDataList, instrument]);

  function getData() {
    getProcessedDataList({
      instrument: instrument ? instrument.id : id ?? null, start: new Date(startDate.current).toLocaleDateString('en-GB', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).split('/').reverse().join('-'), end: new Date(endDate.current).toLocaleDateString('en-GB', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).split('/').reverse().join('-')
    })
  }

  useEffect(() => {
    if (processedDataList.results) {
      let tableList = []
      let instrument = processedDataList.instrument
      setInstrumentTab(
        <InstrumentTab currentInstrument={instrument} changeInstrument={setInstrument}></InstrumentTab>
      )
      setLatestTab(
        <LatestTab instrument={instrument} latest={processedDataList.latest} location={processedDataList.location}></LatestTab>
      )
      setCategoryTab(
        <CategoryTab instrument={instrument} latest={processedDataList.latest} location={processedDataList.location} category={processedDataList.category}></CategoryTab>
      )
      const publicHolidays = processedDataList.public_holidays || [];
      for (const [key, value] of Object.entries(processedDataList.results)) {
        let leq5 = []
        let leq1 = []
        const leq12 = new Array(2).fill(null)
        const doseAndMaxList = new Array(24).fill(null);

        // Determine if this date is a Sunday or Public Holiday per NEA standard
        // The date key represents the SGT calendar date; the "noise day" starts at 7am
        const dateObj = new Date(key + 'T00:00:00+08:00');
        const isSunday = dateObj.getDay() === 0; // 0 = Sunday
        const isSundayOrPH = isSunday || publicHolidays.includes(key);

        // dedupe identical timestamps to avoid duplicate entries causing misalignment
        const seen5 = new Set();
        const seen1 = new Set();
        for (let elem of value) {
          if (elem.type_of_leq === "5min") {
            if (!seen5.has(elem.timestamp)) {
              leq5.push(elem);
              seen5.add(elem.timestamp);
            }
          } else if (elem.type_of_leq === "1h") {
            if (!seen1.has(elem.timestamp)) {
              leq1.push(elem);
              seen1.add(elem.timestamp);
            }
            if (elem.is_displayed) {
              addToDoseAndMaxList(elem, doseAndMaxList, processedDataList.location.category)
            }
          } else if (elem.type_of_leq === "12h") {
            addToLeq12(elem, leq12)
            if (elem.is_displayed) {
              addToDoseAndMaxList(elem, doseAndMaxList, processedDataList.location.category)
            }
          }
        }
        processedDataList.location.category === "B - Residential" ? tableList.push(
          <TableB leq1={leq1} leq5={leq5} leq12={leq12} doseAndMaxList={doseAndMaxList} date={key} isSundayOrPH={isSundayOrPH}></TableB>
        ) : tableList.push(
          <TableA leq1={leq1} leq5={leq5} leq12={leq12} doseAndMaxList={doseAndMaxList} date={key} isSundayOrPH={isSundayOrPH}></TableA>
        )
      }
      setTables(tableList)
    }
  }, [processedDataList])

  useEffect(() => {
    const fetchData = () => {
      // Your code to fetch data here
      getData()
    };

    // Set up a timer to fetch data every 5 seconds
    const timer = setInterval(fetchData, 5 * 60 * 1000);

    // Clean up the timer when the component unmounts
    return () => {
      clearInterval(timer);
    };
  }, []);

  const generatePDF = async () => {
    setPrinting(true);
    const pdf = new jsPDF({
      orientation: 'p',
      unit: 'px',
      format: 'a4',
      compress: true,
    });

    const pdfWidth = pdf.internal.pageSize.width;
    const pdfHeight = pdf.internal.pageSize.height;

    const leftMargin = 20;
    const rightMargin = 20;
    const topStart = 50;
    const footerMargin = 40;
    const componentYOffset = 10;

    // Scale 1.0 avoids massive memory footprint on large multi-day exports
    const html2canvasOptions = {
      scale: 1.0,
      useCORS: true,
      logging: false,
    };

    // 1. Capture static header elements once before the loop
    const instrumentContainer = document.getElementById('instrument-tab-id');
    const latestContainer = document.getElementById('latest-tab-id');

    let imgDataInstrument = null;
    let imgWidthInstrument = 0;
    let imgHeightInstrument = 0;

    let imgDataLatest = null;
    let imgWidthLatest = 0;
    let imgHeightLatest = 0;

    if (instrumentContainer && latestContainer) {
      const canvasInstrument = await html2canvas(instrumentContainer, html2canvasOptions);
      const canvasLatest = await html2canvas(latestContainer, html2canvasOptions);

      // Use JPEG with 0.65 quality to keep file size ultra compact
      imgDataInstrument = canvasInstrument.toDataURL('image/jpeg', 0.65);
      imgDataLatest = canvasLatest.toDataURL('image/jpeg', 0.65);

      imgWidthInstrument = pdfWidth - leftMargin - rightMargin;
      imgHeightInstrument = (canvasInstrument.height * imgWidthInstrument) / canvasInstrument.width;

      imgWidthLatest = pdfWidth - leftMargin - rightMargin;
      imgHeightLatest = (canvasLatest.height * imgWidthLatest) / canvasLatest.width;
    }

    // 2. Loop through table pages
    for (let index = 0; index < tables.length; index++) {
      // Adding of Geomotion Logo with alias 'GM_LOGO' so it is stored ONCE in the PDF
      pdf.addImage(logo, 'PNG', leftMargin, 0, 120, topStart, 'GM_LOGO', 'FAST');

      const tableContainer = document.getElementById(`table-item-${index}`);

      if (tableContainer && imgDataInstrument && imgDataLatest) {
        const canvas = await html2canvas(tableContainer, html2canvasOptions);
        const imgData = canvas.toDataURL('image/jpeg', 0.65);

        const imgWidth = pdfWidth - leftMargin - rightMargin;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        let scaleFactor = 1;
        const totalHeight = imgHeightInstrument + imgHeightLatest + imgHeight + componentYOffset * 2;
        const availableHeight = pdfHeight - topStart - footerMargin;

        if (totalHeight > availableHeight) {
          scaleFactor = availableHeight / totalHeight;
        }

        pdf.addImage(imgDataInstrument, 'JPEG', leftMargin, topStart, scaleFactor * imgWidthInstrument, scaleFactor * imgHeightInstrument, 'HEADER_INST', 'FAST');
        pdf.addImage(imgDataLatest, 'JPEG', leftMargin, topStart + scaleFactor * (imgHeightInstrument + componentYOffset), scaleFactor * imgWidthLatest, scaleFactor * imgHeightLatest, 'HEADER_LATEST', 'FAST');
        pdf.addImage(imgData, 'JPEG', leftMargin, topStart + scaleFactor * (imgHeightInstrument + imgHeightLatest + componentYOffset * 2), scaleFactor * imgWidth, scaleFactor * imgHeight, `TBL_${index}`, 'FAST');
      }

      // Footer
      pdf.setFontSize(8);
      pdf.text("P+65 6546 5585 | F+65 6546 5595 admin@geomtion.com.sg 50 Ubi Cresent, #01-09 Ubi Techpark, Singapore 408568\nGeomotion (Singapore) Pte Ltd Co. UEN: 200104293D geomotion.com.sg", leftMargin, pdfHeight - footerMargin + componentYOffset);

      if (index === tables.length - 1) {
        pdf.save('NoiseMonitoringData.pdf');
      } else {
        pdf.addPage();
      }
    }

    setPrinting(false);
  };

  const handleExportExcelList = () => {
    if (!processedDataList || !processedDataList.results) return;

    const wb = XLSX.utils.book_new();
    const rows = [];

    const rawResults = Array.isArray(processedDataList.results)
      ? processedDataList.results
      : Object.values(processedDataList.results).flat();

    rawResults.forEach((elem) => {
      const dt = new Date(elem.timestamp);
      rows.push({
        'Date': dt.toLocaleDateString('en-GB'),
        'Time': dt.toLocaleTimeString('en-GB'),
        'Type of Leq': elem.type_of_leq,
        'Leq Value (dBA)': elem.leq_value,
        'Threshold (dBA)': elem.threshold,
        'Exceeded Threshold': elem.has_exceeded_threshold ? 'Yes' : 'No',
        'Noise Dose (%)': elem.noise_dose_percentage !== null && elem.noise_dose_percentage !== undefined ? elem.noise_dose_percentage : 'N/A',
        'Max Allowable Leq5min (dBA)': elem.leq5_max !== null && elem.leq5_max !== undefined ? (elem.leq5_max === -1 ? 'OL' : elem.leq5_max) : 'N/A',
      });
    });

    const ws = XLSX.utils.json_to_sheet(rows);
    XLSX.utils.book_append_sheet(wb, ws, "NoiseDataList");

    const instName = instrument?.instrument_name || processedDataList.instrument?.instrument_name || 'NoiseData';
    XLSX.writeFile(wb, `NoiseMonitoringData_${instName}_List.xlsx`);
  };

  const handleExportExcelTable = () => {
    if (!processedDataList || !processedDataList.results) return;

    const wb = XLSX.utils.book_new();

    const inst = processedDataList.instrument || instrument || {};
    const loc = processedDataList.location || {};
    const lat = processedDataList.latest || {};

    const clientName = inst.client_name || "-";
    const projectName = inst.project_name || "-";
    const instrumentName = inst.instrument_name || "-";

    const serialNumber = inst.instrument_serial_number || "-";
    const nextCalDate = inst.next_calibration_date ? inst.next_calibration_date.toString().split("T")[0] : "-";
    const lastCalDate = inst.last_calibration_date ? inst.last_calibration_date.toString().split("T")[0] : "-";
    const locationName = loc.location_name || "-";
    const categoryName = loc.category || "-";
    const latestDateTime = lat.timestamp ? new Date(lat.timestamp).toLocaleString('en-GB', { hour12: true }) : "-";
    const currentLeq5 = lat.leq_value !== null && lat.leq_value !== undefined ? lat.leq_value : "-";
    const latestStatus = lat.status || "-";

    const headers = [
      'Date',
      'Time (hr/5min)',
      '00',
      '05',
      '10',
      '15',
      '20',
      '25',
      '30',
      '35',
      '40',
      '45',
      '50',
      '55',
      'Leq1hr/Accum',
      'Leq12hr/Accum',
      'Current Dose %',
      'Max. Allow / Leq5min',
    ];

    const sheetData = [
      ['Client Name', 'Project Name', 'Instrument Name'],
      [clientName, projectName, instrumentName],
      [],
      ['S/No', 'Next Calibration Date', 'Last Calibration Date', 'Location', 'Category', 'Date and Time', 'Current LEQ 5', 'Status'],
      [serialNumber, nextCalDate, lastCalDate, locationName, categoryName, latestDateTime, currentLeq5, latestStatus],
      [],
      headers,
    ];

    const merges = [];
    const publicHolidays = processedDataList.public_holidays || [];
    const isCategoryB = processedDataList.location?.category === "B - Residential";

    let currentRow = 7; // rows 0-5 are top summary tables and spacers, row 6 is matrix header

    for (const [date, records] of Object.entries(processedDataList.results)) {
      const dateParts = date.split('-');
      const formattedToday = `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;
      const currentDateObj = new Date(date + 'T00:00:00+08:00');
      const tomorrowObj = new Date(currentDateObj);
      tomorrowObj.setDate(currentDateObj.getDate() + 1);
      const formattedTomorrow = tomorrowObj.toLocaleDateString("en-GB");

      const isSunday = currentDateObj.getDay() === 0;
      const isSundayOrPH = isSunday || publicHolidays.includes(date);

      const leq5Map = {};
      const leq1Map = {};
      const leq12 = [null, null];
      const doseAndMaxList = new Array(24).fill(null);

      const seen5 = new Set();
      const seen1 = new Set();
      for (const elem of records) {
        if (elem.type_of_leq === "5min") {
          if (!seen5.has(elem.timestamp)) {
            leq5Map[new Date(elem.timestamp).toISOString()] = elem;
            seen5.add(elem.timestamp);
          }
        } else if (elem.type_of_leq === "1h") {
          if (!seen1.has(elem.timestamp)) {
            leq1Map[new Date(elem.timestamp).toISOString()] = elem;
            seen1.add(elem.timestamp);
          }
          if (elem.is_displayed) {
            addToDoseAndMaxList(elem, doseAndMaxList, processedDataList.location?.category);
          }
        } else if (elem.type_of_leq === "12h") {
          addToLeq12(elem, leq12);
          if (elem.is_displayed) {
            addToDoseAndMaxList(elem, doseAndMaxList, processedDataList.location?.category);
          }
        }
      }

      // Helper to generate ISO matching SGT noise day
      const sgtToUtcIso = (hour, minute) => {
        let y = parseInt(dateParts[0], 10), m = parseInt(dateParts[1], 10) - 1, d = parseInt(dateParts[2], 10);
        if (hour < 7) {
          d += 1;
        }
        const sgtMs = Date.UTC(y, m, d, hour, minute, 0);
        const utcMs = sgtMs - (8 * 3600 * 1000);
        return new Date(utcMs).toISOString();
      };

      const dayStartRow = currentRow;

      for (let index = 0; index < 24; index++) {
        const hour = index <= 16 ? index + 7 : index - 17;
        const timeStr = `${hour}:00`;
        const rowDate = index < 17 ? formattedToday : formattedTomorrow;

        // 5-min readings
        const mins = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];
        const mValues = mins.map(m => {
          const iso = sgtToUtcIso(hour, m);
          const item = leq5Map[iso];
          return item ? item.leq_value : "-";
        });

        // Leq1hr
        let leq1Val = "N.A.";
        if (isCategoryB) {
          if (!isSundayOrPH && index >= 12) {
            const iso = sgtToUtcIso(hour, 0);
            const item = leq1Map[iso];
            leq1Val = item ? item.leq_value : "-";
          }
        }

        // Leq12hr
        let leq12Val = "";
        if (!isCategoryB) {
          if (index === 0) leq12Val = leq12[0] ? leq12[0].leq_value : "-";
          else if (index === 12) leq12Val = leq12[1] ? leq12[1].leq_value : "-";
        } else {
          if (index === 0) leq12Val = leq12[0] ? leq12[0].leq_value : "-";
          else if (index === 12) leq12Val = "N.A.";
        }

        // Dose and Max Leq5min
        let doseVal = "";
        let maxVal = "";
        const getDisplayDoseMax = (data, isNoiseDose) => {
          if (!data) return "N.A.";
          const val = isNoiseDose ? data.noise_dose_percentage : data.leq5_max;
          const roundingDP = isNoiseDose ? 2 : 1;
          const recordDate = new Date(date + 'T00:00:00+08:00');
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          const isPastDate = recordDate.getTime() < today.getTime();

          if (isPastDate && !isNoiseDose && index === 0) return "EOD";
          if (val === null || val === undefined) return "N.A.";
          if ((val === "-1.00" || val === -1) && !isNoiseDose) return "OL";
          if ((val === "101.00" || val === 101) && isNoiseDose) return "OL";
          return `${parseFloat(val).toFixed(roundingDP)}${isNoiseDose ? "%" : " dBA"}`;
        };

        if (!isCategoryB) {
          if (index === 0) {
            doseVal = getDisplayDoseMax(doseAndMaxList[0], true);
            maxVal = getDisplayDoseMax(doseAndMaxList[0], false);
          } else if (index === 12) {
            doseVal = getDisplayDoseMax(doseAndMaxList[12], true);
            maxVal = getDisplayDoseMax(doseAndMaxList[12], false);
          }
        } else {
          if (index === 0) {
            doseVal = getDisplayDoseMax(doseAndMaxList[0], true);
            maxVal = getDisplayDoseMax(doseAndMaxList[0], false);
          } else if (isSundayOrPH && index === 12) {
            doseVal = "N.A.";
            maxVal = "N.A.";
          } else if (!isSundayOrPH && index >= 12) {
            doseVal = getDisplayDoseMax(doseAndMaxList[index], true);
            maxVal = getDisplayDoseMax(doseAndMaxList[index], false);
          }
        }

        sheetData.push([
          rowDate,
          timeStr,
          mValues[0],
          mValues[1],
          mValues[2],
          mValues[3],
          mValues[4],
          mValues[5],
          mValues[6],
          mValues[7],
          mValues[8],
          mValues[9],
          mValues[10],
          mValues[11],
          leq1Val,
          leq12Val,
          doseVal,
          maxVal,
        ]);
        currentRow++;
      }

      // Add cell merges matching the UI:
      // 1. Date column: 7:00-23:00 (17 rows) and 0:00-6:00 (7 rows)
      merges.push({ s: { r: dayStartRow, c: 0 }, e: { r: dayStartRow + 16, c: 0 } });
      merges.push({ s: { r: dayStartRow + 17, c: 0 }, e: { r: dayStartRow + 23, c: 0 } });

      // 2. Leq12hr column: Day (indices 0..11) and Night (indices 12..23)
      merges.push({ s: { r: dayStartRow, c: 15 }, e: { r: dayStartRow + 11, c: 15 } });
      merges.push({ s: { r: dayStartRow + 12, c: 15 }, e: { r: dayStartRow + 23, c: 15 } });

      // 3. Current Dose % and Max. Allow / Leq5min columns:
      if (!isCategoryB) {
        // Category A/C: 12-hour day and 12-hour night
        merges.push({ s: { r: dayStartRow, c: 16 }, e: { r: dayStartRow + 11, c: 16 } });
        merges.push({ s: { r: dayStartRow + 12, c: 16 }, e: { r: dayStartRow + 23, c: 16 } });

        merges.push({ s: { r: dayStartRow, c: 17 }, e: { r: dayStartRow + 11, c: 17 } });
        merges.push({ s: { r: dayStartRow + 12, c: 17 }, e: { r: dayStartRow + 23, c: 17 } });
      } else {
        // Category B: 12-hour daytime
        merges.push({ s: { r: dayStartRow, c: 16 }, e: { r: dayStartRow + 11, c: 16 } });
        merges.push({ s: { r: dayStartRow, c: 17 }, e: { r: dayStartRow + 11, c: 17 } });

        // Sunday/PH nighttime is merged N.A.
        if (isSundayOrPH) {
          merges.push({ s: { r: dayStartRow + 12, c: 16 }, e: { r: dayStartRow + 23, c: 16 } });
          merges.push({ s: { r: dayStartRow + 12, c: 17 }, e: { r: dayStartRow + 23, c: 17 } });
        }
      }
    }

    const ws = XLSX.utils.aoa_to_sheet(sheetData);

    // Apply cell merges
    ws['!merges'] = merges;

    // Auto-fit / set readable column widths
    ws['!cols'] = [
      { wch: 16 }, // Col 0: Date / Client Name / S/No
      { wch: 22 }, // Col 1: Time / Project Name / Next Calibration Date
      { wch: 32 }, // Col 2: 00 / Last Calibration Date / Instrument Name
      { wch: 24 }, // Col 3: 05 / Location
      { wch: 18 }, // Col 4: 10 / Category
      { wch: 24 }, // Col 5: 15 / Date and Time
      { wch: 16 }, // Col 6: 20 / Current LEQ 5
      { wch: 14 }, // Col 7: 25 / Status
      { wch: 8 },  // Col 8: 30
      { wch: 8 },  // Col 9: 35
      { wch: 8 },  // Col 10: 40
      { wch: 8 },  // Col 11: 45
      { wch: 8 },  // Col 12: 50
      { wch: 8 },  // Col 13: 55
      { wch: 15 }, // Col 14: Leq1hr/Accum
      { wch: 15 }, // Col 15: Leq12hr/Accum
      { wch: 16 }, // Col 16: Current Dose %
      { wch: 22 }, // Col 17: Max. Allow / Leq5min
    ];

    XLSX.utils.book_append_sheet(wb, ws, "NoiseTable");

    const instName = instrument?.instrument_name || processedDataList.instrument?.instrument_name || 'NoiseData';
    XLSX.writeFile(wb, `NoiseMonitoringData_${instName}_Table.xlsx`);
  };

  const handleExportCSV = () => {
    if (!processedDataList || !processedDataList.results) return;

    const wb = XLSX.utils.book_new();
    const rows = [];

    const rawResults = Array.isArray(processedDataList.results)
      ? processedDataList.results
      : Object.values(processedDataList.results).flat();

    rawResults.forEach((elem) => {
      const dt = new Date(elem.timestamp);
      rows.push({
        'Date': dt.toLocaleDateString('en-GB'),
        'Time': dt.toLocaleTimeString('en-GB'),
        'Type of Leq': elem.type_of_leq,
        'Leq Value (dBA)': elem.leq_value,
        'Threshold (dBA)': elem.threshold,
        'Exceeded Threshold': elem.has_exceeded_threshold ? 'Yes' : 'No',
        'Noise Dose (%)': elem.noise_dose_percentage !== null && elem.noise_dose_percentage !== undefined ? elem.noise_dose_percentage : 'N/A',
        'Max Allowable Leq5min (dBA)': elem.leq5_max !== null && elem.leq5_max !== undefined ? (elem.leq5_max === -1 ? 'OL' : elem.leq5_max) : 'N/A',
      });
    });

    const ws = XLSX.utils.json_to_sheet(rows);
    XLSX.utils.book_append_sheet(wb, ws, "NoiseData");

    const instName = instrument?.instrument_name || processedDataList.instrument?.instrument_name || 'NoiseData';
    XLSX.writeFile(wb, `NoiseMonitoringData_${instName}.csv`, { bookType: 'csv' });
  };

  return (
    <div className="nm-page-wrapper">
      <div className="nm-page-inner">
        <Grid container spacing={3} alignItems="stretch" style={{ width: "100%", margin: 0 }}>
          <Grid item xs={12} lg={6} style={{ display: "flex" }}>
            <div style={{ display: "flex", flexDirection: "column", gap: "20px", width: "100%" }}>
              <div id="instrument-tab-id" style={{ width: "100%" }}>{instrumentTab}</div>
              <div id="latest-tab-id" style={{ width: "100%" }}>{latestTab}</div>
            </div>
          </Grid>

          <Grid item xs={12} lg={6} style={{ display: "flex" }}>
            <div style={{ width: "100%", minHeight: "450px", display: "flex" }}>
              <GMap instruments={[instrument ?? processedDataList.instrument]} height={"450px"}></GMap>
            </div>
          </Grid>
        </Grid>

        <div style={{ height: "20px" }} />

        <div id="category-tab-id" style={{ width: "100%" }}>
          {categoryTab}
        </div>

        {!printing ? (processedDataList.results) ?
        <Grid container spacing={3} style={{ width: "100%", margin: 0 }}>
          <Grid item xs={12}>
            <div className='row' style={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
              <div className='col'>
                <Grid item xs={12} style={{ display: 'flex', flexDirection: 'row' }}>
                  <div style={{ fontWeight: 'bold', marginRight: '10px' }}>
                    Start Date
                  </div>
                  <DatePicker
                    placeholderText='Start Date'
                    selected={startDate.current}
                    onChange={(e) => { startDate.current = e; setStart(e) }}
                    name="startDate"
                    dateFormat="MMMM d, yyyy"
                    autoComplete='off'
                    popperPlacement="top-start"
                  />
                </Grid>
              </div>
              <br />
              <div className='col'>
                <Grid item xs={8} style={{ display: 'flex', flexDirection: 'row' }}>
                  <div style={{ fontWeight: 'bold', marginRight: '10px' }}>
                    End Date
                  </div>
                  <DatePicker
                    placeholderText='Complete Date'
                    selected={endDate.current}
                    onChange={(e) => { endDate.current = e; setEnd(e) }}
                    name="completeDate"
                    dateFormat="MMMM d, yyyy"
                    autoComplete='off'
                    popperPlacement="top-start"
                  />
                </Grid>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '15px' }}>
            <Button
              onClick={getData}
              size="medium"
              variant="contained"
              color="primary"
            >
              Get Data
            </Button>
            <Button
              id="export-dropdown-button"
              aria-controls={isExportOpen ? 'export-dropdown-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={isExportOpen ? 'true' : undefined}
              onClick={handleExportClick}
              size="medium"
              variant="contained"
              color="success"
              endIcon={<ExpandMoreIcon />}
            >
              Export
            </Button>
            <Menu
              id="export-dropdown-menu"
              anchorEl={exportAnchorEl}
              open={isExportOpen}
              onClose={handleExportClose}
              MenuListProps={{
                'aria-labelledby': 'export-dropdown-button',
              }}
            >
              <MenuItem onClick={() => handleExportOption('pdf')}>
                Export as PDF (.pdf)
              </MenuItem>
              {/* <MenuItem onClick={() => handleExportOption('excel-list')}>
                Export as Excel List (.xlsx)
              </MenuItem> */}
              <MenuItem onClick={() => handleExportOption('excel-table')}>
                Export as Excel Noise Table (.xlsx)
              </MenuItem>
              {/* <MenuItem onClick={() => handleExportOption('csv')}>
                Export as CSV (.csv)
              </MenuItem> */}
            </Menu>
          </Grid>
        </Grid>
        :
        <div style={{ width: "100%", textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '50vh', fontSize: '24px' }}>
          There are no data to be displayed
        </div> :
        <div style={{ width: "100%", textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px' }}>
          {/* The CircularProgress component with a color and size */}
          <CircularProgress color="primary" size={60} />
        </div>
      }
      <br />
      <Grid container spacing={3} style={{ width: "100%", margin: 0 }}>
        <Grid item xs={12}>
          <div style={{ width: "100%", overflowX: "auto" }}>
            <div style={{ width: "100%" }}>
              {tables.map((table, index) => (
                <div className="table-item" id={`table-item-${index}`} key={index}>
                  {table}
                </div>
              ))}
            </div>
            <br />
          </div>
        </Grid>
      </Grid>
      </div>
    </div>
  );
};

export default DataTable;


